var ifastLoginError = angular
    .module("iFAST.loginError", [
        "iFAST.common",
        "ngRoute",
        "ngResource",
        "ngCookies",
        "noCAPTCHA"
    ])
    .config(function ($routeProvider) {
        "use strict";
        $routeProvider
            .when("/ssoLoginError",
                {templateUrl: require("./login_error.tpl.html"),
                controller: "loginErrorCtrl",
                controllerAs: "loginErrorCtrl"})
            .otherwise({
                redirectTo: "/ssoLoginError"
            });
    }).run(["$rootScope", function ($rootScope) {
        "use strict";
        //This is a fix for loading client config from main css file.
        var clientCd  = "";
        if(location.hostname.indexOf("-") === -1) {
            clientCd  = location.hostname.substr(0, location.hostname.indexOf("."));
        } else {
            clientCd  = location.hostname.substr(0, location.hostname.indexOf("-"));
        }
        var clientCssUrl = "_assets/css/" + clientCd +".css";
        /*var clientLessUrl = "_less/" + clientCd +".properties.less";*/
        $rootScope.stylesheets = [
            { href: clientCssUrl, type:"text/css", rel:"stylesheet"}/*,
            { href: clientLessUrl, type:"text/css", rel:"stylesheet/less"}*/

            //clientLessUrl css doesn't load fast enough before the script loads.
            // instead, using danny's old method for loading local less.prop
        ];

        $rootScope.respondJS = "vendor/respond/src/respond.js";
    }]);

ifastLoginError
    .filter("sceTrustAsHtml", ["$sce", function($sce) {
        "use strict";
        return function(displayField) {
            return $sce.trustAsHtml(displayField + "");
        };
    }]);

ifastLoginError
    .factory("loginLocation", ["$location", "iFastConstants", function ($location) {
        "use strict";

        //handles the cases where absolute url contains "j_security_check".
        var url = function (url) {
            var jSecurityCheck = "j_security_check";
            var absUrl = $location.absUrl();
            if (0 < absUrl.indexOf(jSecurityCheck)) {
                absUrl = absUrl.replace(jSecurityCheck, "");
                var indexOfHash = absUrl.indexOf("#");
                if (0 < indexOfHash) {
                    absUrl = absUrl.substring(0, indexOfHash) + "#";
                }
                location.href = absUrl + url;
            } else {
                $location.url(url);
            }
        };

        //clientCd
        var clientCd = function () {
            var clientCd = "";
            if ($location.host().indexOf("-") === -1) {
                clientCd = $location.host().substr(0, $location.host().indexOf("."));
            } else {
                clientCd = $location.host().substr(0, $location.host().indexOf("-"));
            }

            return clientCd;
        };

        return {
            url: url,
            clientCd: clientCd
        };

    }]);

angular.module("iFAST.common", []);


// WEBPACK FOOTER //
// ./WebContent/src/login/loginError.js